import { useDispatch, useSelector } from "react-redux"
import { authMapState } from "../../redux/auth.mapstate"
import { setAuthDataAction} from "../../redux/auth.action"
import setAuthHeaderAxios from "../../utils/setAuthToken"
import { exchangeJoulyToken } from "../../services/authAPI"



export interface Config {

}

export default function useAuthCore(config?:Config) {

  const dispatch = useDispatch()
  const { auth : authState} = useSelector(authMapState)

  // Reads jouly's opaque session token from the URL params, exchanges it
  // against the backend for a locally-signed JWT, then stores the JWT in
  // Redux + axios defaults. Subsequent calls go through api-data-platform's
  // strict auth middleware which only accepts JWTs it issued itself.
  const authenticateByURL = async () => {
    const params = new URLSearchParams(window.location.search)
    const joulyToken = params.get('t')
    const accountId = params.get('accountId')
    const userId = params.get('userId')

    if(!joulyToken || !accountId || !userId) return

    try {
      const response = await exchangeJoulyToken({ token: joulyToken, userId, accountId })
      setAuthHeaderAxios({ token: response.token, accountId: response.accountId, userId: response.userId })
      dispatch(setAuthDataAction({ token: response.token, accountId: response.accountId, userId: response.userId }))
    } catch (error: any) {
      // Pas l'erreur axios entiere : sa config contient le token opaque jouly.
      console.error("Token exchange failed:", error?.response?.status, error?.message)
    }
  }

  const logOutUser = () => {
    setAuthHeaderAxios(null)
    dispatch(setAuthDataAction(null))
  
  }

  const getUserIsAuthenticated = () => {
    return authState.authData !== null
  }

  const setHeaderAuthToRequest = () => {
    if(authState.authData) {
      setAuthHeaderAxios(authState.authData)
    }
  }

  const getAccountIdUser = () => {
    return authState.authData?.accountId || null
  }

  const getUserId = () => {
    return authState.authData?.userId || null
  }

  return {
    authenticateByURL,
    authState: authState,
    logOutUser,
    getUserIsAuthenticated,
    setHeaderAuthToRequest,
    getAccountIdUser,
    getUserId

  }
}
